module.exports = __webpack_public_path__ + "static/media/carnavals.ec91844a.jpg";